import useForm, { ErrorsType, FormHookReturnValue, ValuesType } from '~/hooks/use-form';
import React from 'react';

export type Props = {
  children: (params: FormHookReturnValue) => React.ReactNode;
  onSubmit: (values: ValuesType) => Promise<any> | any;
  onValidate: (values: ValuesType) => Promise<ErrorsType> | ErrorsType;
  initialValues: ValuesType;
};

export default function Form(props: Props) {
  let { children, onSubmit, onValidate, initialValues } = props;

  let hookReturn = useForm({ submit: onSubmit, validate: onValidate, initialValues });

  return <form onSubmit={() => hookReturn.submit()}>{children(hookReturn)}</form>;
}
